// React
import React from 'react';
// Material ui
import { makeStyles } from '@material-ui/core';
// constants
import { LAZY_BACKGROUND_VISIBLE_CLASS_NAME } from './lazyBacgroundImage.constant';
import initLazyBackgroundImageListener from './initLazyBackgroundImageListener';
var refElement = React.createRef();
var useStyles = makeStyles({
    root: function (_a) {
        var _b;
        var imageUrl = _a.imageUrl, placeholderImageUrl = _a.placeholderImageUrl;
        return (_b = {},
            _b["&." + LAZY_BACKGROUND_VISIBLE_CLASS_NAME] = {
                backgroundImage: "url(" + imageUrl + ")",
            },
            _b.backgroundImage = "url(" + placeholderImageUrl + ")",
            _b);
    }
});
/**
 * LazyBackgroundImage component
 * @param Wrapper -  Wrapper element of the component
 * @param children - Component's children elements
 * @param className - Wrapper element class name
 * @param placeholderImageUrl - Placeholder image url
 * @param imageUrl - Image url
 */
var LazyBackgroundImage = function (_a) {
    var Wrapper = _a.Wrapper, children = _a.children, className = _a.className, placeholderImageUrl = _a.placeholderImageUrl, imageUrl = _a.imageUrl;
    // Component states
    var _b = React.useState(false), isVisible = _b[0], setIsVisible = _b[1];
    // Component style classes
    var classes = useStyles({ imageUrl: imageUrl, placeholderImageUrl: placeholderImageUrl });
    var wrapperClassName = (isVisible ? LAZY_BACKGROUND_VISIBLE_CLASS_NAME : '') + " " + classes.root + " " + (className ? className : '');
    React.useLayoutEffect(function () {
        var current = refElement.current;
        if (current) {
            initLazyBackgroundImageListener(current, setIsVisible);
        }
    }, []);
    return (React.createElement(Wrapper, { ref: refElement, className: wrapperClassName }, children));
};
export default LazyBackgroundImage;
//# sourceMappingURL=LazyBackgroundImage.js.map